import { PlantExternalId, PlantExtIdsRequestModel } from '../models';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { CustomHttpErrorResponse, Error } from '../../../../../common/constants/error';
import { NotificationService } from '../../../../../common';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { PlantExternalIdsService } from './plant-external-ids.service';
import { PlantExternalIDsInitialState, PlantExternalIDsLoad } from './plant-external-ids.actions';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface PlantExternalIdsStateModel {
  externalIds: PlantExternalId[];
  loaded: boolean;
}

const initialState: PlantExternalIdsStateModel = {
  externalIds: [],
  loaded: false,
};

@State<PlantExternalIdsStateModel>({
  name: 'plantExternalIds',
  defaults: initialState,
})
@Injectable()
export class PlantExternalIdsState {
  constructor(
    private plantExternalIdsService: PlantExternalIdsService,
    private notificationService: NotificationService,
  ) {}
  @Selector()
  static getState(state: PlantExternalIdsStateModel): PlantExternalIdsStateModel {
    return state;
  }
  @Selector()
  static getLoaded(state: PlantExternalIdsStateModel): boolean {
    return state.loaded;
  }
  @Selector()
  static getList(state: PlantExternalIdsStateModel): PlantExternalId[] {
    return state.externalIds;
  }

  @Action(PlantExternalIDsLoad)
  getPlants(
    ctx: StateContext<PlantExternalIdsStateModel>,
    { payload }: { payload: PlantExtIdsRequestModel },
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.plantExternalIdsService.getAvailableExternalIds(payload).pipe(
      take(1),
      map((externalIds: PlantExternalId[]) => {
        ctx.patchState({ externalIds, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(PlantExternalIDsInitialState)
  setInitialState(ctx: StateContext<PlantExternalIdsStateModel>): void {
    ctx.setState(initialState);
  }
}
